import { useMemo } from 'react';
import { Grid, Typography } from '@material-ui/core';
import { IdentityForm } from './components';
import { useCompany, useCompanyFunctions } from 'contexts/CompanyContext';
import { useHistory } from 'react-router-dom';
import { useProvider, useProviderFunctions } from 'contexts/ProviderContext';
import MaiaLogo from 'components/MaiaLogo';
import MaiaText from 'components/MaiaText';
import RegisterLayout from 'pages/RegisterLayout';
import routes from 'config/routes';
import sideImage from '_assets/register/Identity.svg';
import useStyles from './styles';

const getInitialIdentityState = (provider, company) => ({
  birthday: provider?.birthday ?? '1970-01-01',
  birthplace: provider?.birthplace ?? '',
  country: provider?.country ?? 'France',
  gender: provider?.sexe ?? '',
  firstName: provider?.first_name ?? '',
  identityURL: company?.identityURL ?? '',
  lastName: provider?.last_name ?? '',
  phone: provider?.phone ?? '',
});

const RegisterIdentity = () => {
  const classes = useStyles();
  const history = useHistory();

  const { currentCompany } = useCompany();
  const { editCompanyDocument } = useCompanyFunctions();
  const { provider } = useProvider();
  const { editProvider } = useProviderFunctions();

  const identity = useMemo(
    () => getInitialIdentityState(provider, currentCompany),
    [currentCompany, provider]
  );

  const handleSubmitForm = async (values, document) => {
    const body = {
      birthday: values.birthday,
      birthplace: values.birthplace,
      country: values.country,
      firstName: values.firstName,
      gender: values.gender,
      lastName: values.lastName,
      phone: values.phone,
    };

    const updated = await editProvider(body);
    let docUpdated = false;
    if (document?.file) {
      let formData = new FormData();
      formData.append('file', document?.file);
      docUpdated = await editCompanyDocument(
        currentCompany?.id,
        'identity',
        formData,
        document?.url,
      );
    }

    if (updated) history.push(routes.home.root);

    return { documentUpdated: docUpdated, updated };
  };

  const SideComponent = () => (
    <Grid container direction='column' style={{ height: 'auto' }}>
      <Grid container item justifyContent='center'>
        <MaiaLogo />
      </Grid>

      <Grid container item justifyContent='center' style={{ marginTop: '8vh' }}>
        <img src={sideImage} alt='Identity' width={150} />
      </Grid>

      <Grid container item justifyContent='center' style={{ marginTop: '3vh' }}>
        <Typography className={classes.text} align='center' variant='h3'>
          Nous devons vérifier votre identité.
        </Typography>
        <Typography className={classes.text} align='center' variant='h3' style={{ marginTop: '3vh' }}>
          Malheureusement c’est une obligation légale que <MaiaText /> doit respecter
        </Typography>
        <Typography className={classes.text} align='center' variant='h3' style={{ marginTop: '3vh' }}>
          Merci de votre compréhension
        </Typography>
      </Grid>
    </Grid>
  );

  return (
    <RegisterLayout SideComponent={<SideComponent />}>
      <Grid container direction='column' style={{ height: 'auto' }}>
        <Grid className={classes.header} container item justifyContent='center'>
          <Grid className={classes.title} container item xs={12} md={9} justifyContent='center'>
            <Typography variant='h1'>Votre identité</Typography>
          </Grid>

          <Grid className={classes.title} container item xs={12} md={9} justifyContent='center'>
            <Typography align='center' variant='h2'>
              Veuillez compléter vos informations d’identités.
            </Typography>
          </Grid>
        </Grid>

        <Grid container item justifyContent='center' style={{ flexGrow: 1 }}>
          <IdentityForm
            identity={identity}
            onCancel={() => history.push(routes.home.root)}
            onSubmit={handleSubmitForm}
          />
        </Grid>
      </Grid>
    </RegisterLayout>
  );
};

export default RegisterIdentity;
